<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
      <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <strong> Users </strong><small>choose role</small>
        </div>
        <div>
          <!-- <b-nav role tabs>
            <b-tab title="Coaches" active></b-tab>
            <b-nav-item title="Coaches" active>Coaches</b-nav-item>
            <b-nav-item>Parents</b-nav-item>
            <b-nav-item>Players</b-nav-item>
            <b-nav-item disabled>Fans</b-nav-item>
          </b-nav> -->
          <b-tabs role tabs>
            <b-tab title="Coaches" active>
              <b-card id="coachesTable">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="coaches" :fields="coachesFields" :current-page="currentPageCoach" :per-page="perPage" @row-clicked="coachClicked">
                  <template slot="lastName" slot-scope="data">
                    <strong>{{data.item.lastName}}</strong>
                  </template>
                  <template slot="created" slot-scope="data">
                    <strong>{{new Date(data.item.created).toGMTString()}}</strong>
                  </template>
                </b-table>
                <nav>
                  <b-pagination size="sm" :total-rows="coaches.length" :per-page="perPage" v-model="currentPageCoach" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-card>
            </b-tab>
            <b-tab title="Parents">
              <b-card id="parentsTable">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="parents" :fields="parentsFields" :current-page="currentPageParent" :per-page="perPage" @row-clicked="parentClicked">
                  <template slot="lastName" slot-scope="data">
                    <strong>{{data.item.lastName}}</strong>
                  </template>
                  <template slot="created" slot-scope="data">
                    <strong>{{new Date(data.item.created).toGMTString()}}</strong>
                  </template>
                </b-table>
                <nav>
                  <b-pagination size="sm" :total-rows="parents.length" :per-page="perPage" v-model="currentPageParent" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-card>
            </b-tab>
            <b-tab title="Players">
              <b-card id="coachesTable">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="players" :fields="playersFields" :current-page="currentPagePlayer" :per-page="perPage" @row-clicked="playerClicked">
                  <template slot="lastName" slot-scope="data">
                    <strong>{{data.item.lastName}}</strong>
                  </template>
                  <template slot="created" slot-scope="data">
                    <strong>{{new Date(data.item.created).toGMTString()}}</strong>
                  </template>
                </b-table>
                <nav>
                  <b-pagination size="sm" :total-rows="players.length" :per-page="perPage" v-model="currentPagePlayer" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-card>
            </b-tab>
            <b-tab title="Fans" disabled></b-tab>
          </b-tabs>
        </div>

        <br>
        <b-row class="align-items-center">
            <b-col cols="12" xl= "2" sm="2" md="2" class="mb-3 mb-xl-0" >
              <b-button v-on:click="addUserButton" block variant="primary">Add User</b-button>
            </b-col>
        </b-row>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { db } from '@/config/devowqlo';
export default {
  name: 'Users',
  firebase: {
    coaches: db.ref('users').child("coaches"),
    parents: db.ref('users').child("parents"),
    players: db.ref('users').child("players")
  },
  props: {
    caption: {
      type: String,
      default: 'Users'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      coachesFields: [
        {key: 'lastName'},
        {key: 'name'},
        {key: 'email'},
        {key: 'created'}
      ],
      parentsFields: [
        {key: 'lastName'},
        {key: 'name'},
        {key: 'email'},
        {key: 'created'}
      ],
      playersFields: [
        {key: 'lastName'},
        {key: 'name'},
        {key: 'position'},
        {key: 'email'},
        {key: 'created'}
      ],
      userArray: [],
      currentPageCoach: 1,
      currentPageParent: 1,
      currentPagePlayer: 1,
      perPage: 10,
      totalRows: 0
    }
  },
  computed: {
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount (users) {
      return users.length
    },
    userLink (id) {
      return `users/${id}`
    },
    coachClicked (user) {
      const userLink = `users/${user['.key']}` + '&&' + 'coach'
      this.$router.push({path: userLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    parentClicked (user) {
      const userLink = `users/${user['.key']}`  + '&&' + 'parent'
      this.$router.push({path: userLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    playerClicked (user) {
      const userLink = `users/${user['.key']}`  + '&&' + 'player'
      this.$router.push({path: userLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addUserButton () {
      this.$router.push({path: 'users/adduser'})
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
